/**
 * Shared constants for the curriculum and gating logic.
 */

export const PREP_CATEGORY_IDS = [
    'd8eb9872-59a4-41db-9494-4a542c9fd461', // Critical Thinking
    'd4ef9f9f-f991-4ba9-bbc9-7cf17c1b2f10', // Study Skills
    'f6914f53-f7e9-4222-9b9a-c91110d215e8', // Career Exploration
    'f6d4b1f0-2cff-43b3-8302-b19c668d7aa1', // Personal Finance
];

export const isPrepSubject = (categoryId: string) => PREP_CATEGORY_IDS.includes(categoryId);
